import React, { Component } from 'react'
import { VideoComponent } from '../components'
import { connect } from 'react-redux'
import { saveVideo, resetVideo } from '../actions'
import { updateRequestState, getRequestState } from '../../../shared/actions'
import { isEqual } from 'lodash'

class Video extends Component {
    constructor(props) {
        super(props)

        this.state = {
            step: 1,
            constraints: { audio: false, video: { facingMode: "environment" } },
            video: props.video,
            isCameraOn: false
        }
    }

    componentDidMount = () => {
        this.props.getRequestState()
        if (this.props.history.location.params && this.props.history.location.params.to === 'preview') {
            this.resetVideo()
        } else if (this.state.video) {
            this.setState({ step: 2 })
        }
    }

    handleChange = (key, value) => {
        this.setState({ [key]: value })
    }

    goToScreen = (key, params) => {
        if (this.props.history.location && this.props.history.location.params) {
            this.props.history.push(this.props.history.location.params.to)
        } else {
            this.props.history.push({
                pathname: key,
                params: params,
            })
        }
    }

    resetVideo = () => {
        this.setState({ step: 1, video: '' })
        this.props.resetVideo()
    }

    goBack = () => {
        const { requestState: { template } } = this.props
        if (this.state.step === 2) {
            this.resetVideo()
        } else {
            this.props.history.replace(template.version === 1 ? 'homeImage' : 'addressProof')
        }
    }

    onRecordingComplete = (video) => {
        this.setState({ step: 2, video: video })
    }

    submit = () => {
        if (!isEqual(this.state.video, this.props.video)) {
            this.props.updateRequestState({
                upload: ["home_video"],
                state: "home_video_captured",
                data: {
                    home_video: this.state.video && this.state.video.videoUrl
                },
                nextRoute: 'preview'
            })
        } else {
            this.goToScreen('preview')
        }
    }


    render() {
        const { language, languageJSON } = this.props
        const { constraints, step, video, isCameraOn } = this.state
        return (
            <VideoComponent
                language={language}
                languageJSON={languageJSON}
                goBack={this.goBack}
                step={step}
                isCameraOn={isCameraOn}
                constraints={constraints}
                onRecordingComplete={this.onRecordingComplete}
                submit={this.submit}
                video={video}
                goToScreen={this.goToScreen}
                handleChange={this.handleChange}
            />
        )
    }
}

const mapStateToProps = ({ language: { language, languageJSON }, video: { video },  shared: { requestState } }) => ({
    language,
    languageJSON,
    video,
    requestState
})

const mapDispatchToProps = {
    saveVideo,
    resetVideo,
    updateRequestState,
    getRequestState
}

export default connect(mapStateToProps, mapDispatchToProps)(Video)
